// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/account/v1/vision_preferences.proto (package protos.vision.account.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/account/v1/vision_preferences.proto.
 */
export const file_vision_account_v1_vision_preferences: GenFile = /*@__PURE__*/
  fileDesc("Cip2aXNpb24vYWNjb3VudC92MS92aXNpb25fcHJlZmVyZW5jZXMucHJvdG8SGHByb3Rvcy52aXNpb24uYWNjb3VudC52MSKLAgoRVmlzaW9uUHJlZmVyZW5jZXMSTwoTYXBwZWFyYW5jZV9hcnRib2FyZBgBIAEoCzIyLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5WaXNpb25BcHBlYXJhbmNlU2V0dGluZ3MSUQoVYXBwZWFyYW5jZV9zdG9yeWJvYXJkGAIgASgLMjIucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLlZpc2lvbkFwcGVhcmFuY2VTZXR0aW5ncxJSChZhcHBlYXJhbmNlX3Zpc2lvbmJvYXJkGAMgASgLMjIucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLlZpc2lvbkFwcGVhcmFuY2VTZXR0aW5ncyLeAQoYVmlzaW9uQXBwZWFyYW5jZVNldHRpbmdzEkIKEGNhcmRfc2l6ZV9wcmVzZXQYASABKA4yKC5wcm90b3MudmlzaW9uLmFjY291bnQudjEuQ2FyZFNpemVQcmVzZXQSOwoMYXNwZWN0X3JhdGlvGAIgASgOMiUucHJvdG9zLnZpc2lvbi5hY2NvdW50LnYxLkFzcGVjdFJhdGlvEkEKD3RodW1ibmFpbF9zY2FsZRgDIAEoDjIoLnByb3Rvcy52aXNpb24uYWNjb3VudC52MS5UaHVtYm5haWxTY2FsZSqDAQoOQ2FyZFNpemVQcmVzZXQSHAoYQ0FSRF9TSVpFX1BSRVNFVF9VTktOT1dOEAASGgoWQ0FSRF9TSVpFX1BSRVNFVF9TTUFMTBABEhsKF0NBUkRfU0laRV9QUkVTRVRfTUVESVVNEAISGgoWQ0FSRF9TSVpFX1BSRVNFVF9MQVJHRRADKngKC0FzcGVjdFJhdGlvEhgKFEFTUEVDVF9SQVRJT19VTktOT1dOEAASGwoXQVNQRUNUX1JBVElPX0hPUklaT05UQUwQARIXChNBU1BFQ1RfUkFUSU9fU1FVQVJFEAISGQoVQVNQRUNUX1JBVElPX1ZFUlRJQ0FMEAMqYAoOVGh1bWJuYWlsU2NhbGUSGwoXVEhVTUJOQUlMX1NDQUxFX1VOS05PV04QABIXChNUSFVNQk5BSUxfU0NBTEVfRklUEAESGAoUVEhVTUJOQUlMX1NDQUxFX0ZJTEwQAmIGcHJvdG8z");

/**
 * @generated from message protos.vision.account.v1.VisionPreferences
 */
export type VisionPreferences = Message<"protos.vision.account.v1.VisionPreferences"> & {
  /**
   * @generated from field: protos.vision.account.v1.VisionAppearanceSettings appearance_artboard = 1;
   */
  appearanceArtboard?: VisionAppearanceSettings | undefined;

  /**
   * @generated from field: protos.vision.account.v1.VisionAppearanceSettings appearance_storyboard = 2;
   */
  appearanceStoryboard?: VisionAppearanceSettings | undefined;

  /**
   * @generated from field: protos.vision.account.v1.VisionAppearanceSettings appearance_visionboard = 3;
   */
  appearanceVisionboard?: VisionAppearanceSettings | undefined;
};

/**
 * Describes the message protos.vision.account.v1.VisionPreferences.
 * Use `create(VisionPreferencesSchema)` to create a new message.
 */
export const VisionPreferencesSchema: GenMessage<VisionPreferences> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_vision_preferences, 0);

/**
 * @generated from message protos.vision.account.v1.VisionAppearanceSettings
 */
export type VisionAppearanceSettings = Message<"protos.vision.account.v1.VisionAppearanceSettings"> & {
  /**
   * @generated from field: protos.vision.account.v1.CardSizePreset card_size_preset = 1;
   */
  cardSizePreset: CardSizePreset;

  /**
   * @generated from field: protos.vision.account.v1.AspectRatio aspect_ratio = 2;
   */
  aspectRatio: AspectRatio;

  /**
   * @generated from field: protos.vision.account.v1.ThumbnailScale thumbnail_scale = 3;
   */
  thumbnailScale: ThumbnailScale;
};

/**
 * Describes the message protos.vision.account.v1.VisionAppearanceSettings.
 * Use `create(VisionAppearanceSettingsSchema)` to create a new message.
 */
export const VisionAppearanceSettingsSchema: GenMessage<VisionAppearanceSettings> = /*@__PURE__*/
  messageDesc(file_vision_account_v1_vision_preferences, 1);

/**
 * @generated from enum protos.vision.account.v1.CardSizePreset
 */
export enum CardSizePreset {
  /**
   * @generated from enum value: CARD_SIZE_PRESET_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: CARD_SIZE_PRESET_SMALL = 1;
   */
  SMALL = 1,

  /**
   * @generated from enum value: CARD_SIZE_PRESET_MEDIUM = 2;
   */
  MEDIUM = 2,

  /**
   * @generated from enum value: CARD_SIZE_PRESET_LARGE = 3;
   */
  LARGE = 3,
}

/**
 * Describes the enum protos.vision.account.v1.CardSizePreset.
 */
export const CardSizePresetSchema: GenEnum<CardSizePreset> = /*@__PURE__*/
  enumDesc(file_vision_account_v1_vision_preferences, 0);

/**
 * @generated from enum protos.vision.account.v1.AspectRatio
 */
export enum AspectRatio {
  /**
   * @generated from enum value: ASPECT_RATIO_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: ASPECT_RATIO_HORIZONTAL = 1;
   */
  HORIZONTAL = 1,

  /**
   * @generated from enum value: ASPECT_RATIO_SQUARE = 2;
   */
  SQUARE = 2,

  /**
   * @generated from enum value: ASPECT_RATIO_VERTICAL = 3;
   */
  VERTICAL = 3,
}

/**
 * Describes the enum protos.vision.account.v1.AspectRatio.
 */
export const AspectRatioSchema: GenEnum<AspectRatio> = /*@__PURE__*/
  enumDesc(file_vision_account_v1_vision_preferences, 1);

/**
 * @generated from enum protos.vision.account.v1.ThumbnailScale
 */
export enum ThumbnailScale {
  /**
   * @generated from enum value: THUMBNAIL_SCALE_UNKNOWN = 0;
   */
  UNKNOWN = 0,

  /**
   * @generated from enum value: THUMBNAIL_SCALE_FIT = 1;
   */
  FIT = 1,

  /**
   * @generated from enum value: THUMBNAIL_SCALE_FILL = 2;
   */
  FILL = 2,
}

/**
 * Describes the enum protos.vision.account.v1.ThumbnailScale.
 */
export const ThumbnailScaleSchema: GenEnum<ThumbnailScale> = /*@__PURE__*/
  enumDesc(file_vision_account_v1_vision_preferences, 2);

